import type * as React from 'react';
import { del } from '@Domain/Api';
import organizationWorkflowRestored, {
	type OrganizationWorkflowRestoredAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowRestored';
import organizationWorkflowRestorationFailed, {
	type OrganizationWorkflowRestorationFailedAction,
} from '@Application/Organizations/Workflows/Actions/organizationWorkflowRestorationFailed';
import type RestoreOrganizationWorkflow from '@Application/Organizations/Workflows/Commands/RestoreOrganizationWorkflow';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationWorkflowRestoredAction | OrganizationWorkflowRestorationFailedAction;

export default (command: RestoreOrganizationWorkflow) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${parameters.api.host}/api/organizations/${command.organizationId}/workflows/${command.workflowKey}/deactivations`,
			);

			const action = organizationWorkflowRestored(
				{ workflowKey: command.workflowKey },
				command.organizationId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationWorkflowRestorationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
